<div class="dialog-container">
  <h1 mat-dialog-title>{{ title }}</h1>

  <div mat-dialog-content class="dialog-content">
    <form [formGroup]="form">
      <section class="receive-fields">
        <mat-form-field appearance="outline">
          <mat-label>Almacén</mat-label>
          <mat-select formControlName="idalmacen">
            <mat-option *ngFor="let store of stores" [value]="store.id">{{ store.nombre }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Producto</mat-label>
          <input matInput [matAutocomplete]="product" formControlName="idproducto" placeholder="Seleccione un producto">
          <mat-autocomplete autoActiveFirstOption #product="matAutocomplete" [displayWith]="displayProduct" (optionSelected)="productChanged()">
            <mat-option *ngFor="let product of products" [value]="product">{{ product.nombre }}</mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Comunidad</mat-label>
          <mat-select formControlName="idcomunidad">
            <mat-option *ngFor="let comunidad of comunidades" [value]="comunidad.id">{{ comunidad.nombre }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Fecha</mat-label>
          <input matInput type="text" [matDatepicker]="picker" formControlName="fecha">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Cantidad</mat-label>
          <input matInput type="number" formControlName="cantidad">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Numeración</mat-label>
          <input matInput type="text" formControlName="numeracion">
        </mat-form-field>
      </section>
    </form>
  </div>

  <div mat-dialog-actions class="actions">
    <button mat-stroked-button (click)="close()">Cancelar</button>
    <button mat-raised-button color="primary" (click)="save()">Guardar</button>
  </div>
</div>
